import { Link } from 'react-router-dom';
import type { ServerSetting } from '../../../services/adminServerSettings';
import { UnitsSwitchKey, appliedValue, currentImageTag } from './unitsPolicy';

function whatTheManagerDoes(on: boolean, imageTagSet: boolean): string {
  if (!on) return 'The unit manager does nothing.';
  return imageTagSet ? 'The unit manager follows the policy below.' : 'No image tag: no new units.';
}

export default function UnitsSwitchState({ settings }: { settings: ServerSetting[] }) {
  const on = appliedValue(settings, UnitsSwitchKey) === 'true';
  const imageTagSet = currentImageTag(settings) != null;
  return (
    <div className="card" style={{ padding: 16, display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
      <span style={{ fontWeight: 600, fontSize: 14 }}>Worker units</span>
      <span className={on ? 'chip ok' : 'chip warn'}><span className="dot" />{on ? 'On' : 'Off'}</span>
      <span className="t-body" style={{ fontSize: 13 }}>
        {whatTheManagerDoes(on, imageTagSet)} <Link to="/admin/settings">Switch it in Server settings.</Link>
      </span>
    </div>
  );
}
